<style scoped>
.header-template .router-link-active {
  color: white;
}
.desktop-header  {
    width: 100%;
    margin: 0 auto;
}
/* @media (min-width: 1281px) {
  .desktop-header  {
    width: 100%;
    margin: 0 auto;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .desktop-header  {
    width: 35vw;
    margin: 0 auto;
  }
} */

@media (max-width: 767px) {
  .notification-button {
    display: none;
  }
}

@media (min-width: 768px) {
  .menu-badge {
    display: none;
  }
}

.desktop-header {
  /* transition:background 1s ease; */
}

</style>

<style lang="scss">
  .menu-container{
    .ivu-badge-count{
        min-width: 15px;
        height: 15px;
        top: -5px;
        line-height: 14px;
        padding: 0px 2px;
        font-size: 10px;
        background: var(--toolbar-menu-badge-color);
        box-shadow: 0 0 0 1px var(--toolbar-menu-badge-color);
    }
  }
  .bg-experience {

  }
</style>


<template>
    <div style="background: var(--toolbar-color)" :style="{position:'fixed', left: '0', right: '0', top: '0', zIndex: '10'}" class="bg-experience" :class="('type' in mobileView && mobileView.type) ? 'mobile-web-view m-header':'desktop-header'">
        <Row class="header-template" type="flex" justify="center">
            <i-col :xs="24" :sm="24" :md="24" :lg="24" style="height:60px;position:relative" :style="mStyle">
                <p style="color: white;font-size: 20px;padding: 14px;" align="center">
                  <span style="position:absolute;right:15px">
                    <router-link class="notification-button" v-if="showNotification && userInfo && userInfo.user_type !== 'guest'" to="/notifications" style="color:#333;margin-right:15px">
                      <Badge :count="notificationCount" overflow-count="99">
                        <svg style="vertical-align: middle;stroke:var(--toolbar-menu-button-color)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-bell"><path d="M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0"></path></svg>
                      </Badge>
                    </router-link>
                    <!-- <router-link v-if="isMenu() != '/menu'" to="/menu" style="color:#333"> -->
                    <a class="menu-container" v-if="isMenu() != '/menu' && isShowBurger" @click="toggleDrawer">
                      <svg style="vertical-align: middle;stroke:var(--toolbar-menu-button-color)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
                      <span class="menu-badge">
                        <Badge :count="notificationCount" overflow-count="99"/>
                      </span>
                    </a>
                    <!-- </router-link> -->
                    <a v-if="isMenu() == '/menu'"  @click="goBackHistory()" style="color:#333">
                      <svg style="vertical-align: middle" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </a>
                  </span>
                  <span style="position:absolute;left:15px;margin-top:2px">
                    <!-- <a @click="onIOSGoHome()" v-if="!backNavigation && isIOS">
                      <Icon type="grid" size="30" style="color:var(--toolbar-back-button-color)" />
                    </a> -->
                    <a style="color:black !important" @click="goBackHistory()" v-if="backNavigation">
                      <svg style="vertical-align: middle;stroke:var(--toolbar-back-button-color)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
                    </a>
                  </span>
                  <router-link tag="span" to="/home" style="vertical-align:middle;">
                    <h3 style="padding: 0 30px;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;"
                      :style="textStyle"
                      v-if="getTheme && (bgImage || getTheme.toolbar_title)">{{getTheme.toolbar_title}}</h3>
                    <!-- <img v-else style="margin-top: -7px" src="/img/header.png" width="140vh"/> -->
                  </router-link>
                </p>
            </i-col>
        </Row>
        <p :style="{background: ($store.state.base.isOnline) ? '#333333':'#f72b00'}" style="font-size:12px;padding: 3px 0;color: white; height: 24px;" align="center">
          <small v-if="(!$store.state.base.isOnline)" style="position:absolute;left:0;margin: 1px 5px;padding:1px 5px;border-radius:10px;background: rgb(48, 48, 48);">Offline Mode</small>{{pageTitle}}</p>
    </div>
</template>

<script>
import manifest from '../../public/manifest.json'
import VueCookie from 'vue-cookie'
import { mapGetters } from 'vuex'
import Utils from '@/utils.js'
import _ from 'lodash'

export default {
  name: 'AppHeaderComponent',
  mounted () {
    this.backNavigation =
      !!('isVisibleBack' in this.$route.meta && this.$route.meta.isVisibleBack)
    if (
      this.$store.state.base.auth &&
      'access_token' in this.$store.state.base.auth
    ) {
      // this.$store.dispatch('user/getUserInfo')
      }
  },
  data () {
    return {
      backNavigation: false,
      manifest,
      notifTimer: null
    }
  },
  methods: {
    stopNotifTimer() {
      if (this.notifTimer) clearInterval(this.notifTimer)
    },
    toggleDrawer: function() {
      BroadcastEvent.$emit("onToggleBurger");
    },
    isMenu () {
      return this.$route.path
    },
    onIOSGoHome() {
      if ( VueCookie.get('os_type') === "ios" ) {
        window.webkit.messageHandlers.onNativeCalled.postMessage({
          name: 'onGoHome',
          params: {}
        })
      }
    },
    goBackHistory () {
      if ( VueCookie.get('os_type') === "ios" ) {
        window.webkit.messageHandlers.onNativeCalled.postMessage({
          name: 'onReturnHistory',
          params: {}
        })
      }

      // if( this.$route.name == "ModuleComponent" || this.$route.name == "ModuleComponent-Brand" && !this.$route.query.floating)
      //   this.$router.replace( JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_TRACK`)) )
      // else
        window.history.back()
    }
  },
  watch: {
    $route: function (n, o) {
      this.backNavigation =
        !!('isVisibleBack' in this.$route.meta && this.$route.meta.isVisibleBack)
    },
    'userInfo'(n, o) {
      if (n && n.user_type !== 'guest') {
        this.notifTimer = setInterval(() => {
          console.log('get notifications every minute')
          this.$store.dispatch('notification/getNotifications', 1)
        }, 60000)
      } else {
        this.stopNotifTimer()
      }
    },
    notificationCount(n, o) {
      if (
        n > 0 &&
        n > o &&
        window.localStorage.getItem("notification_enabled") !== "true" &&
        this.userInfo.user_type !== "guest"
      )
        this.$store.commit("doBeep", true, { root: true });
    }
  },
  beforeDestroy() {
    this.stopNotifTimer()
  },
  computed: {
    showNotification() {
      if(this.$route.name === 'OnBoarding-Brand') {
        return false
      }
      return true
    },
    isShowBurger() {
      if (this.$route.name == "OnBoarding-Brand" || this.$router.name == "OnBoarding")
        return false;
      if (this.$route.name == `/${process.env.VUE_APP_DEV_ECOSYSTEM}/verify`)
        return false;
      if (this.$route.name == "LoginComponent-Brand" || this.$router.name == "LoginComponent")
        return false;
      return true;
    },
    ...mapGetters(["getPageTitle"]),
    ...mapGetters('user', ['getTheme']),
    bgImage() {
      if (this.getTheme && this.getTheme.toolbar_background_image_uri)
        return process.env.VUE_APP_BASE_IMAGE_URL + "large" + this.getTheme.toolbar_background_image_uri;
      return '';
    },
    mStyle() {
      if( this.bgImage ) {
        return {
          backgroundImage: 'url('+this.bgImage+')',
          backgroundSize: 'auto 60px',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }
      }
      return {}
    },
    getToolbarColor() {
      if(this.getTheme && this.getTheme.toolbar_title_color)
        return this.getTheme.toolbar_title_color;
      return "auto"
    },
    textStyle() {
      if( this.getTheme && this.getTheme.toolbar_title) {
        console.log(this.getTheme.toolbar_title.length)
        if( this.getTheme.toolbar_title.length > 25)
          return {
            lineHeight: "18px",
            fontSize: "17px",
            color: this.getToolbarColor
          }
      }

      return {
        lineHeight: "30px",
        fontSize: "1.3rem",
        color: this.getToolbarColor
      }
    },
    isIOS() {
      return ( VueCookie.get('os_type') === "ios" ) ? true : false;
    },
    userInfo: {
      get () {
        return this.$store.state.user.info
      }
    },
    notificationCount() {
      if(this.userInfo && this.userInfo.user_type == 'guest') return 0;
      // return this.$store.state.notification.status.new;
      // TODO:

      let count = this.$store.state.notification.data.filter((notification) => {
        return notification.is_new
      }).length
      
      return count;
    },
    mobileView: {
      get () {
        return this.$store.state.mobileView
      }
    },
    singleResource: {
      get() {
        return this.$store.state.resource.singleResource;
      }
    },
    pageTitle: {
      get () {
        if(this.$route.name == 'SubMenu' || this.$route.name == 'SubMenu-Brand'){
          return this.$store.state.resource.resources.submenu.title || "SubMenu"
        }
        
        if(this.$route.name == 'LoginComponent' || this.$route.name == 'LoginComponent-Brand') {
          return (this.$route.query.type && this.$route.query.type == 'signup') ? 'Register' : 'Login';
        }

        if(this.$route.name == 'SubMenu' || this.$route.name == 'SubMenu-Brand'){
          return this.$store.state.resource.resources.submenu.title || "SubMenu"
        }

        if(this.$route.name == 'ModuleComponent' || this.$route.name == 'TrackComponent' ||
           this.$route.name == 'TrackComponent-Brand' || this.$route.name == 'ModuleComponent-Brand'){
          // return this.getPageTitle
          return this.$route.query.title || this.getPageTitle
        }

        if (this.$route.path == 'OrganizationComponent' || this.$route.name == 'OrganizationComponent-Brand'){
          return this.$route.query.title || this.$route.meta.title
        }

        if(this.$route.name == 'Extras' || this.$route.name == 'Extras-Brand'){
          // return this.getPageTitle
          return this.$route.query.title || this.getPageTitle
        }

        if( this.$route.path == '/resources/list' && this.$route.query.type === 'special_project')
          return 'Special Project'

        if(this.$route.path.startsWith('/resources/')) {
          if(this.singleResource.data.type == 'alliance') {
            return 'Organizations'
          } else if(this.singleResource.data.type == 'interest') {
            return 'Advocacies'
          } else if(this.singleResource.data.type == 'special_projects') {
            return 'Special Projects'
          } else if(this.singleResource.data.type == 'event') {
            return 'Events'
          } else if(this.singleResource.data.type == 'badge') {
            return 'Badge'
          } else if (this.singleResource.data.title == 'TM Leadership') {
            return 'TM Leadership'
          }
        }

        if ('section' in this.$route.query && (this.$route.name == "ProfilePageView" || this.$route.name == "ProfilePageView-Brand")){
          if ('careteam' in this.$route.query && this.$route.query.careteam == 1){
             return 'My Team'
          }
          return 'My Bookmarks'
        }

        return 'title' in this.$route.meta && this.$route.meta.title
          ? this.$route.meta.title
          : ''
      }
    }
  }
}
</script>
